import { Input, Image, Text, View } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface State {
  id?: number;
  old_password: string;
  new_password: string;
}

export default class Password extends Base {
  public config: Config = {
    navigationBarTitleText: '修改密码'
  };

  public state: State = {
    old_password: "",
    new_password: ""
  };

  public didMount() {
    this.getUserInfo()
  }

  private link = url => {
    history.push(url);
  }

  private getUserInfo = async() => {
    const res = await this.apiClient.base.userListInfo()
    console.log(res);
    if(res && res.status == 10000){
      this.setState({
        id: res.body.id
      })
    }
    
  }

  private submit = async() => {
    const { id, old_password, new_password } = this.state;

    if(old_password == ''){
      toast.error("请输入原密码",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }
    if(new_password == ''){
      toast.error("请输入新密码",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }

    const res = await this.apiClient.base.userEdit({
      id,
      old_password, 
      new_password 
    })
    console.log(res);
    if(res && res.status == 10000){
      toast.info("修改成功",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      setTimeout(function(){
        history.goBack()
      },1000)
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    
  }

  private valueChange = (name,e) => {
    // console.log(name,[name],name.indexOf('.'),e.target.value);
    this.setState({[name]:  e.target.value})
  }

  public render() {
    const { old_password, new_password } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        
        
        <View className={styles.main}>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>原密码*</Text>
              <View className={styles.lis_r}>
                <Input
                  value={old_password}
                  name="old_password"
                  type="number"
                  className={styles.input}
                  placeholder="请填写原密码"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>新密码*</Text>
              <View className={styles.lis_r}>
                <Input
                  value={new_password}
                  name="new_password"
                  type="number"
                  className={styles.input}
                  placeholder="请填写新密码"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
          </View>
          <View className={styles.buttonBox}>
              <Text className={styles.adminBtn} onClick={this.submit}>修改密码</Text>
          </View>
        </View>
      </View>
    );
  }
}
